<template>
  <el-dialog
    width="450px"
    :title="title"
    :visible="show"
    :close-on-click-modal="false"
    top="0"
    class="flex-center"
    @close="handleClose">
    <el-form :model="info" label-width="100px" label-position="left" ref="form">
      <template v-for="(item, index) in form">
        <el-form-item
          v-if="item.type === 'select'"
          :label="item['label']"
          :key="index"
          :prop="item.key"
          :rules="{ required: true, message: `请选择${item.label}`, trigger: 'blur' }">
          <el-select v-model="info[item['key']]">
            <el-option
              v-for="(option, optionIndedx) in dangerList"
              :key="optionIndedx"
              :label="option.cellName"
              :value="option.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-else
          :label="item['label']"
          :key="index"
          :prop="item.key"
          :rules="{ required: true, message: `请填写${item.label}`, trigger: 'blur' }">
          <el-input v-model="info[item['key']]"></el-input>
        </el-form-item>
      </template>
      <el-form-item label-width="0" class="dialog-btn-box">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import { setStorage, getStorage } from '@/utils/localStorage';
  import common from "./mixin/common";
  import { mapGetters } from 'vuex';
  export default {
    name: "editDialog",
    mixins: [common],
    props: {
      title: {
        type: String,
        default: ''
      },
      show: {
        type: Boolean,
        default: false
      },
      form: {
        type: Array,
        default: () => []
      },
      model: {
        type: String,
        default: ''
      },
      //  设备id
      devId: {
        type: Number,
        default: 0
      }
    },
    computed: {
      ...mapGetters([
        'dangerList'
      ])
    },
    data() {
      return {
        info: {
          id: null
        }
      }
    },
    methods: {
      handleClose() {
        this.$refs.form.resetFields();
        Object.assign(this.$data, this.$options.data());
        this.$emit('close', this.model);
      },
      async handleConfirm() {
        try {
          await this.$refs.form.validate();
          const { appKey, appSecret, id } = this.info;
          const params = { appKey, appSecret, id: id ? id : '' }
          this.editToken(params).then(() => {
            setStorage('appToken', JSON.stringify(params));
            this.$emit('success');
            this.handleClose();
          })
          // this.$emit('close', this.model);
        } catch (e) {
          return false;
        }
      }
    },
    watch: {
      show(val) {
        if (val) {
           this.getKey().then(res => {
             if (res) {
               this.info = res;
             }
             // const deviceToken = res
          })

        }
      }
    }
  }
</script>

<style scoped lang="scss">
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-btn-box {
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.el-select {
  width: 100%;
}
</style>